import styled from 'styled-components'
import COLORS from '@colors'

export const Main = styled.div`
  -webkit-print-color-adjust: exact;
  width: ${props => (props.print ? '595.28px' : '100vw')};
  height: 100vh;
  padding: ${props => (props.print ? '0' : '16px')};
  font-size: ${props => (props.print ? '8px' : '14px')};
`

export const Container = styled.div`
  width: 100%;
  max-width: ${props => (props.print ? '595.28px' : '1360px')};
  margin: ${props => (props.print ? '0' : '0 auto')};
`

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`

export const MapImgContainer = styled.img`
  background-color: ${COLORS.gray28};
  background-repeat: no-repeat;
  height: ${props => (props.print ? '128px' : '270px')};
  width: ${props => (props.print ? '303px' : '640px')};
`

export const StreetViewContainer = styled.div`
  height: ${props => (props.print ? '128px' : '270px')};
  width: ${props => (props.print ? '340px' : '720px')};
`

export const Header = styled.h2`
  color: ${COLORS.leather};
  font-weight: bold;
  font-size: 20px;
  margin-top: ${props => (props.print ? '10px' : '40px')};
  margin-bottom: ${props => (props.print ? '8px' : '32px')};
`

export const AddressContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  ${props => !props.print && `border: 1px solid ${COLORS.whiteD};`};
`

export const AddressWrapper = styled.div`
  padding: ${props => (props.print ? '0' : '16px')};
  flex-grow: 1;
`

export const AreaWrapper = styled.div`
  padding: ${props => (props.print ? '0' : '16px')};
  ${props => !props.print && `border-right: 1px solid ${COLORS.whiteD};`}
`

export const Text = styled.p`
  color: ${props =>
    props.gold
      ? COLORS.leather
      : props.dark
      ? COLORS.gray45
      : props.print
      ? COLORS.black
      : COLORS.whiteA1};
  ${({ textFont }) => textFont && `font: ${textFont}`};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  font-size: ${({ print, title, table }) =>
    print && (title || table ? '11px' : '13px')};
`

export const Download = styled.button`
  background-color: transparent;
  border: 0;
  color: ${COLORS.gray45};
  cursor: pointer;
  display: flex;
  align-items: center;
  outline: 0;
  padding: 29px 16px;

  svg {
    margin-right: 8px;
  }
`

export const DataSection = styled.div`
  margin-top: 45px;
  display: flex;
  flex-wrap: wrap;
`

export const Section = styled.div`
  width: ${props => (props.print ? '297px' : '500px')};
  display: flex;
  margin-left: ${props => (props.print ? '0' : '100px')};
  margin-bottom: 50px;
`

export const TitleWrapper = styled.div`
  border-top: 1px solid ${COLORS.leather};
  display: flex;
  padding: 6px 0;
  width: ${props => (props.print ? '101px' : '210px')};
`

export const SectionTitle = styled.p`
  color: ${COLORS.leather};
  font-weight: bold;
`

export const IconWrapper = styled.div`
  margin-right: ${props => (props.print ? '4px' : '8px')};
  width: ${props => (props.print ? '14px' : '24px')};
`

export const InfoWrapper = styled.div`
  width: ${props => (props.print ? '185px' : '390px')};
  padding: ${props => (props.print ? '0 0 0 16px' : '0 32px')};
`

export const InfoRow = styled.div`
  padding: ${props => (props.print ? '7px 3px' : '18px 11px')};
  border-bottom: 1px solid ${COLORS.whiteD};
  display: flex;
`
export const InfoColumn = styled.div`
  width: 50%;
`

export const TimeWrapper = styled.div`
  display: flex;
  margin-top: ${props => (props.print ? '0' : '13px')};
  align-items: center;
`

export const TimeMedianContainer = styled.div`
  border-top: 1px solid ${COLORS.whiteD};
  padding: 13px 0;
  margin-left: ${props => (props.print ? '0' : '100px')};
  width: ${props => (props.print ? '260px' : '505px')};
  margin-right: ${props => (props.print ? '27px' : '132px')};
`

export const Time = styled.span`
  border: 1px solid #6f7987;
  border-radius: 4px;
  max-width: ${props => (props.print ? '48px' : '98px')};
  height: ${props => (props.print ? '17px' : '35px')};
  width: ${props => (props.print ? '47px' : '93px')};
  color: #6f7987;
  padding: ${props => (props.print ? '3px' : '7px')};
  text-align: center;
  margin-left: ${props => (props.print ? '15px' : '17px')};
  font-weight: bold;
`

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: 76px;
`

export const MeasuresContainer = styled.div`
  margin-top: ${props => (props.print ? '14px' : '30px')};
  display: flex;
`

export const Measure = styled.div`
  background-color: ${props => props.color};
  color: ${COLORS.white};
  height: ${props => (props.print ? '20px' : '40px')};
  margin-right: ${props => (props.print ? '5px' : '12px')};
  margin-bottom: ${props => (props.print ? '4px' : '8px')};
  width: ${props => (props.print ? '32px' : '62px')};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const RatingWrapper = styled.div`
  display: flex;
  border: 1px solid ${COLORS.whiteD};
  position: relative;
  border-radius: 4px;
  height: ${props => (props.print ? '92px' : '178px')};
  width: ${props => (props.print ? '259px' : '501px')};

  ${props => props.print && 'font-size: 7px;'}
`

export const RatingIconWrapper = styled.div`
  width: ${props => (props.print ? '102px' : '197px')};
  border-right: 1px solid ${COLORS.whiteD};
  margin-right: ${props => (props.print ? '25px' : '50px')};
`
export const RatingHeader = styled.h2`
  color: ${COLORS.leather};
  font-weight: bold;
  font-size: ${props => (props.print ? '10px' : '16px')};
  margin-bottom: ${props => (props.print ? '8px' : '16px')};
`

export const RatingRank = styled.h1`
  font: ${({ print }) => (print ? '20px/10px' : '44px/22px')} Barlow;
  font-weight: bold;
  color: ${COLORS.gray45};
`

export const Needle = styled.span`
  border-left: 1px solid ${COLORS.whiteA1};
  height: ${props => (props.print ? '10px' : '20px')};
  margin-bottom: 6px;
`

export const Table = styled.div`
  width: 100%;
  ${props => props.print && 'font-size: 6px;'}
`

export const Row = styled.div`
  display: flex;
  padding: ${props => (props.print ? '9px 0' : '20px 0')};
  border-bottom: 1px solid ${COLORS.whiteD};
  min-height: ${props => (props.print ? '26px' : '58px')};
  break-inside: ${props => (props.print ? 'avoid-page' : 'unset')};
  ${props => props.header && `border-top: 1px solid ${COLORS.whiteD};`}
  ${({ textCenter }) =>
    textCenter &&
    `
  justify-content: center;
  align-items: center;
  text-align: center;
  `}
`
export const Col = styled.div`
  width: 9.9%;
`

export const RatingFooter = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  bottom: 0;
  left: 0;
  height: ${({ print }) => (print ? '20px' : '43px')};
  font: Bold 14px/17px Barlow;
  letter-spacing: 0;
  background-color: ${COLORS.transparentLeather};
  border-top: 1px solid ${COLORS.whiteD};
  align-items: center;
  padding: ${({ print }) => (print ? '0px 14px' : '0px 28px')};
`

export const RatingBody = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  padding: ${props => (props.print ? '10px 25px' : '20px 49px')};
`

export const SuggestedPriceContainer = styled.div`
  display: flex;
  min-width: 90px;
  justify-content: space-evenly;
`
